import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

// Api Clients
import IncidentClient from "@common/api/IncidentClient";

// Actions
import LoginAction from "@common/redux/actions/LoginAction";
import SetupAction from "@common/redux/actions/SetupAction";
import UnresolvedDisputeAction from "@common/redux/actions/UnresolvedDisputeAction";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";

// Helpers
import unresolvedDisputeCreatePayload from "@common/components/helpers/UnresolvedDispute/unresolvedDisputeSubmission";
import useCustomer from "./useCustomer";
import useCustomerForm from "./useCustomerForm";
import { useEffect } from "react";
import useCompliance from "./useCompliance";

const useUnresolvedDisputeForm = (sigPad) => {
  const methods = useFormContext();
  const {
    formState: { isValid, errors },
  } = methods;

  const { siteGuid } = useSelector((store) => LoginAction.getStatePath(store));
  const data = useSelector((store) =>
    UnresolvedDisputeAction.getStatePath(store),
  );

  const { mode } = useSelector((store) => SetupAction.getStatePath(store));
  const { customers } = useCustomerForm({});
  const setCustomerFormState = (data) => CustomerFormAction.dispatch(data);
  const { onSelectCustomer, onNewCustomer, onEditCustomer, onRemoveCustomer } =
    useCustomer();

  const { resetComplianceForms, submitComplianceForm } = useCompliance();

  useEffect(() => {
    setCustomerFormState({ formType: "unresolvedDispute" });
  }, []);

  useEffect(() => {
    if (!customers) return;
    const hasPhoneOrEmail =
      customers?.[0].phoneNumber || customers?.[0].emailAddress;
    setCustomerFormState({ hasPhoneOrEmail });
  }, [customers]);

  const resetForm = (redirect) => {
    if (sigPad.current) sigPad.current.clear();
    resetComplianceForms(redirect);
  };

  const onSubmit = (data) => {
    if (!isValid) {
      console.error(errors);
      return;
    }
    const payload = unresolvedDisputeCreatePayload(data, siteGuid, mode);
    submitComplianceForm({ client: IncidentClient, payload, resetForm });
  };

  const onSelect = async (customerId) => onSelectCustomer(customerId);

  const handleNewCustomer = (customer) => onNewCustomer(customer);

  const handleEditCustomer = (customer) => onEditCustomer(customer);

  const handleRemoveCustomer = () => onRemoveCustomer();

  const handleExistingCustomer = (response) =>
    handleNewCustomer(response.data[0]);

  return {
    ...data,
    methods,
    resetForm,
    onSubmit,
    mode,
    customers,
    onSelect,
    handleNewCustomer,
    handleEditCustomer,
    handleRemoveCustomer,
    handleExistingCustomer,
  };
};

export default useUnresolvedDisputeForm;
